
const digest = 'ab10f0fe48d8e7a6f5d5b523234f1299fad6a5cca3928883c771bf40d7a75799';
const classes = {"wrapper":"_wrapper_rbz3q_1","edit":"_edit_rbz3q_4"};
const css = `._wrapper_rbz3q_1 {
  position: relative;
}
._wrapper_rbz3q_1 ._edit_rbz3q_4 {
  position: absolute;
  cursor: pointer;
  width: 100%;
  height: 100%;
  border-radius: 100%;
  background-color: rgba(0, 0, 0, 0.4);
  background-image: url("/dist/icons/react/pencil-solid.svg");
  background-size: 40%;
  background-repeat: no-repeat;
  background-position: center;
  top: 0;
  display: none;
  z-index: 2;
}
._wrapper_rbz3q_1:hover ._edit_rbz3q_4 {
  display: block;
  cursor: pointer;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  